<label
	class="ctb-radio-button"
	[class.ctb-radio-button--checked]="state().checked"
	[class.ctb-radio-button--disabled]="isDisabled()"
>
	<input
		class="ctb-radio-button__input"
		type="radio"
		[attr.aria-label]="resolvedAriaLabel()"
		[attr.id]="state().id"
		[attr.name]="state().name"
		[checked]="state().checked"
		[disabled]="isDisabled()"
		[value]="state().value"
		(change)="onNativeChange()"
	/>
	<span class="ctb-radio-button__control" aria-hidden="true"></span>
	@if (state().label !== "") {
		<span class="ctb-radio-button__label">{{ state().label }}</span>
	}
</label>
